// お知らせ情報
import axios from '@/plugins/axios';
import { endpoint } from '@/api/apiConstants';

type mypageNewsInfo = {
  newsId: string;
};

export const getMypageNews = async (params: mypageNewsInfo) => {
  const res = await axios.post(endpoint.getMypageNews, params);
  return res;
};

export const getMypageNewsList = async () => {
  const res = await axios.get(endpoint.getMypageNewsList);
  return res;
};

